// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"237":"dd1e5940a17d4ac8a5c2","402":"11a31677c3f896cf8ff9","818":"4ac0670d12e206eccbc9"}[chunkId] + ".js";
};